// ===========================================================
// ERP CORE - Configuration & Shared Functions
// ===========================================================

// ===========================================================
// ERP CORE - Global Configuration
// ===========================================================

// Global Settings
const GLOBAL_CONFIG = {
  // Tags
  DROPSHIPPER_TAG: 'fishondropshipper',
  WHOLESALE_TAG: 'fishonwholesale',
  RETAIL_TAG: 'fishonretail',
  
  // Currencies
  BASE_CURRENCY: 'AED',    // Base currency for calculations
  SHOP_CURRENCY: window.Shopify?.currency?.active || 'AED',

  EXCHANGE_RATES: {
  'AED': 1.0,
  'USD': 3.676,    // ✅ 3.676 hona chahiye
  'EUR': 3.985,
  'GBP': 4.67,
  'SAR': 0.979,
  'QAR': 1.006,
  'OMR': 9.54,
  'BHD': 9.74
  }
};

function convertToStoreCurrency(amount, fromCurrency) {
  const storeCurrency = GLOBAL_CONFIG.BASE_CURRENCY; // AED
  
  // Same currency? No conversion
  if (!fromCurrency || fromCurrency === storeCurrency) {
    return parseFloat(amount) || 0;
  }
  
  // ✅ HARDCODED RATES - Direct yahan define karo
  const RATES = {
    'USD': 3.676,    // 1 USD = 3.676 AED
    'EUR': 3.985,    // 1 EUR = 3.985 AED
    'GBP': 4.67,     // 1 GBP = 4.67 AED
    'SAR': 0.979,    // 1 SAR = 0.979 AED
    'QAR': 1.006,    // 1 QAR = 1.006 AED
    'OMR': 9.54,     // 1 OMR = 9.54 AED
    'BHD': 9.74,     // 1 BHD = 9.74 AED
    'AED': 1.0       // Base
  };
  
  const rate = RATES[fromCurrency];
  
  if (!rate) {
    console.warn(`No rate for ${fromCurrency}, using 1:1`);
    return parseFloat(amount) || 0;
  }
  
  // ✅ MULTIPLY
  const result = (parseFloat(amount) || 0) * rate;
  console.log(`✅ Converting ${amount} ${fromCurrency} × ${rate} = ${result} AED`);
  return result;
}
function formatPrice(amount, currency = null) {
  // Agar currency nahi di toh store currency use karo
  const symbol = currency || GLOBAL_CONFIG.BASE_CURRENCY;
  return `${symbol} ${parseFloat(amount).toFixed(2)}`;
}

// Helper: Get order currency
function getOrderCurrency(order) {
  // Shopify sometimes stores currency in different fields
  const currency = order.currency || 
                   order.presentment_currency || 
                   order.total_price_set?.presentment_money?.currency_code ||
                   GLOBAL_CONFIG.SHOP_CURRENCY || 
                   'AED';
  
  console.log(`Order ${order.name} currency detected:`, currency);
  return currency;
}

// 0. Canvas "willReadFrequently" polyfill
if (typeof window.Shopify === 'undefined') {
  window.Shopify = {
    shop: "oceanmaniafishing.myshopify.com",
    currency: { active: "AED" }
  };
}
window.__st = window.__st || { cid: undefined };
(() => {
  const original = HTMLCanvasElement.prototype.getContext;
  HTMLCanvasElement.prototype.getContext = function (type, att) {
    if (type === '2d') {
      att = att || {};
      att.willReadFrequently = true;
    }
    return original.call(this, type, att);
  };
})();

// 1. CONFIG
const SYSTEM = {

 BRIDGE: "https://script.google.com/macros/s/AKfycbwlZlFuqlIQ8v_m4TG9-gp1Qxs7NEOJ44DbhyO-cXttFPoYdTzBn6w9tBIeZk2u44CXEg/exec",
  AUTH:   "OceanMania_Secure_998877"
};
const NO_IMAGE = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg ' width='50' height='50' style='background:%23ccc'%3E%3Ctext x='50%25' y='50%25' dy='.3em' text-anchor='middle' font-family='Arial' font-size='10'%3EWG%3C/text%3E%3C/svg%3E";

const PAGE_SIZE = 10;
const USER_ROLE = window.USER_ROLE || "Admin";

// Global State
let MASTER_DB = { products:[], orders:[], customers:[], collections:[], mapping:[], location:null };
let UI_DATA = { inventory:[], orders:[], customers:[] };
let CURRENT_PAGE = { inventory:1, orders:1, customers:1 };

// 2. PAGINATION
const paginate = (items, page, module) => {
  if (!items || !items.length) return [];
  const start = (page - 1) * PAGE_SIZE;
  const slice = items.slice(start, start + PAGE_SIZE);
  renderPaginationUI(module, items.length, page);
  return slice;
};

window.renderPaginationUI = (mod, total, cur) => {
  const holder = document.getElementById(`${mod}-pagination-holder`);
  if (!holder) return;
  const pages = Math.ceil(total / PAGE_SIZE) || 1;
  holder.innerHTML = `
    <div style="display:flex;justify-content:center;align-items:center;gap:20px;padding:15px">
      <button onclick="changeModulePage('${mod}',${cur - 1})"
              ${cur<=1?'disabled style="opacity:.5"':''} class="btn-export">Prev</button>
      <span style="font-weight:bold">Page ${cur} of ${pages}</span>
      <button onclick="changeModulePage('${mod}',${cur + 1})"
              ${cur>=pages?'disabled style="opacity:.5"':''} class="btn-export">Next</button>
    </div>`;
};

window.changeModulePage = (mod, p) => {
  CURRENT_PAGE[mod] = p;
  if (mod === 'inventory' && typeof renderInventoryUI === 'function') renderInventoryUI();
  if (mod === 'orders' && typeof renderOrdersUI === 'function') renderOrdersUI();
  if (mod === 'customers' && typeof renderCustomersUI === 'function') renderCustomersUI();
};

// 3. API BRIDGE
async function queryShopify(endpoint, method='GET', payload=null, fetch_all=false){
  try{
    const res = await fetch(SYSTEM.BRIDGE,{
      method:'POST',
      mode:'cors',
      headers:{'Content-Type':'text/plain'},
      body:JSON.stringify({auth_key:SYSTEM.AUTH, endpoint, method, data:payload, fetch_all})
    });
    return await res.json();
  }catch(e){
    console.error('API Error ('+endpoint+'):',e); return {};
  }
}

// 4. BOOT SYSTEM
async function bootSystem(){
  console.log('ERP Booting...'); 
  window.toggleLoader(true);
  try {
    const [resP, resO, resC, resL, resCl, resMap] = await Promise.all([
      queryShopify('/products.json','GET',null,true),
      queryShopify('/orders.json','GET',null,true),
      queryShopify('/customers.json','GET',null,true),
      queryShopify('/locations.json','GET',null,true),
      queryShopify('/custom_collections.json','GET',null,true),
      queryShopify('/collects.json','GET',null,true)
    ]);

    MASTER_DB.products = resP.products || [];
    MASTER_DB.orders = resO.orders || [];
    MASTER_DB.customers = resC.customers || [];
    MASTER_DB.collections = resCl.custom_collections || [];
    MASTER_DB.mapping = resMap.collects || [];
    MASTER_DB.location = resL.locations?.[0]?.id || null;
    // ✅ NEW: Fetch inventory items for stock aging
    await fetchInventoryItems();
    UI_DATA.inventory = [...MASTER_DB.products];
    UI_DATA.orders = [...MASTER_DB.orders];
    UI_DATA.customers = [...MASTER_DB.customers];

    if (typeof updateStats === 'function') updateStats();
    if (typeof setupFilterDropdowns === 'function') setupFilterDropdowns();
    
    if (typeof renderInventoryUI === 'function') renderInventoryUI();
    if (typeof renderOrdersUI === 'function') renderOrdersUI();
    if (typeof renderCustomersUI === 'function') renderCustomersUI();

    console.log(`Loaded: ${MASTER_DB.orders.length} Orders, ${MASTER_DB.customers.length} Customers`);
  } catch(err) {
    console.error('Boot Error:', err);
  } finally {
    window.toggleLoader(false);
  }
}
async function fetchInventoryItems() {
  try {
    const inventoryItemIds = [];
    MASTER_DB.products.forEach(p => {
      p.variants?.forEach(v => {
        if (v.inventory_item_id) inventoryItemIds.push(v.inventory_item_id);
      });
    });

    if (inventoryItemIds.length === 0) {
      MASTER_DB.inventoryItems = [];
      return;
    }

    // Fetch in batches of 50
    const batchSize = 50;
    MASTER_DB.inventoryItems = [];
    
    for (let i = 0; i < inventoryItemIds.length; i += batchSize) {
      const batch = inventoryItemIds.slice(i, i + batchSize);
      const idsParam = batch.join(',');
      
      const res = await queryShopify(`/inventory_items.json?ids=${idsParam}&limit=250`, 'GET', null, false);
      if (res.inventory_items) {
        MASTER_DB.inventoryItems.push(...res.inventory_items);
      }
    }
    
    console.log(`✅ Loaded ${MASTER_DB.inventoryItems.length} inventory items with dates`);
  } catch (e) {
    console.error('Error fetching inventory items:', e);
    MASTER_DB.inventoryItems = [];
  }
}
// 5. MODULE SWITCHER
window.switchModule = function(moduleName, navId) {
  const adminOnlyModules = ['orders', 'customers'];
  if (USER_ROLE !== 'Admin' && adminOnlyModules.includes(moduleName)) {
    document.getElementById(moduleName + '-target').innerHTML = 
      `<div class="empty-state-container"><h3>🚫 Restricted Access</h3><p>Admins only.</p></div>`;
    alert("🚫 Access Denied");
    return;
  }

  document.querySelectorAll('.main-pane').forEach(p => p.classList.remove('active'));
  document.querySelectorAll('.nav-item').forEach(n => n.classList.remove('active'));
  
  document.getElementById(moduleName + '-pane').classList.add('active');
  document.getElementById(navId).classList.add('active');
  
  const displayTitle = moduleName.toUpperCase();
  document.getElementById('panel-title').innerText = displayTitle;

  const exportBtns = document.querySelectorAll('.btn-export');
  exportBtns.forEach(btn => {
    if(btn.classList.contains('excel')) {
      btn.setAttribute('onclick', `exportToExcel('${displayTitle}')`);
    } else if(btn.classList.contains('pdf')) {
      btn.setAttribute('onclick', `exportToPDF('${displayTitle}')`);
    }
  });

  if (moduleName === 'orders' && typeof renderOrdersUI === 'function') renderOrdersUI();
  if (moduleName === 'customers' && typeof renderCustomersUI === 'function') renderCustomersUI();
  if (moduleName === 'inventory' && typeof renderInventoryUI === 'function') renderInventoryUI();
   if (moduleName === 'stock-aging') {
  if (typeof initStockAgingModule === 'function') {
    initStockAgingModule();
  }
  
  // Hide standard export buttons
  ['att-export-btn', 'inv-export-btn', 'pdf-export-btn'].forEach(id => {
    const btn = document.getElementById(id);
    if (btn) btn.style.display = 'none';
  });
  return;
}
  // Add this case:
if (moduleName === 'dropshipper') {
    if (typeof initDropshipperModule === 'function') {
        initDropshipperModule();
    }
    
    // Hide standard export buttons
    const attBtn = document.getElementById('att-export-btn');
    const invBtn = document.getElementById('inv-export-btn');
    const pdfBtn = document.getElementById('pdf-export-btn');
    
    if (attBtn) attBtn.style.display = 'none';
    if (invBtn) invBtn.style.display = 'none';
    if (pdfBtn) pdfBtn.style.display = 'none';
}

  if (moduleName === 'attendance' && typeof initAttendanceSystem === 'function') {
    initAttendanceSystem();
    
    const attBtn = document.getElementById('att-export-btn');
    const invBtn = document.getElementById('inv-export-btn');
    const pdfBtn = document.getElementById('pdf-export-btn');
    
    if (attBtn) attBtn.style.display = 'inline-block';
    if (invBtn) invBtn.style.display = 'none';
    if (pdfBtn) pdfBtn.style.display = 'none';
  } else {
    const attBtn = document.getElementById('att-export-btn');
    const invBtn = document.getElementById('inv-export-btn');
    const pdfBtn = document.getElementById('pdf-export-btn');
    
    if (attBtn) attBtn.style.display = 'none';
    if (invBtn) invBtn.style.display = 'inline-block';
    if (pdfBtn) pdfBtn.style.display = 'inline-block';
  }
};

// 6. STATS UPDATE (48 Hours Window)
function updateStats() {
  const safeSet = (id, value) => {
    const el = document.getElementById(id);
    if (el) el.innerText = value;
  };

  const now = new Date();
  const fortyEightHoursAgo = new Date(now.getTime() - (48 * 60 * 60 * 1000));

  // Inventory
  const totalProds = MASTER_DB.products.length;
  let totalVars = 0, totalStock = 0, lowStockCount = 0, outOfStockCount = 0;
  MASTER_DB.products.forEach(p => {
    totalVars += p.variants.length;
    p.variants.forEach(v => {
      const qty = parseInt(v.inventory_quantity) || 0;
      totalStock += qty;
      if (qty <= 0) outOfStockCount++;
      else if (qty <= 5) lowStockCount++;
    });
  });

  // Orders
  const allO = MASTER_DB.orders || [];
  const activeOrders = allO.filter(o => {
    const isCancelled = o.cancelled_at !== null;
    const isRefunded = o.financial_status === 'refunded';
    const isArchived = o.closed_at !== null && o.fulfillment_status === 'fulfilled';
    return !isCancelled && !isRefunded && !isArchived;
  });

  const paidFulfilled48h = activeOrders.filter(o => {
    const orderDate = new Date(o.updated_at);
    return o.financial_status === 'paid' && 
           o.fulfillment_status === 'fulfilled' && 
           orderDate >= fortyEightHoursAgo;
  }).length;

  const codFulfilled48h = activeOrders.filter(o => {
    const orderDate = new Date(o.updated_at);
    const isCOD = (o.financial_status === 'pending' || o.financial_status === 'authorized');
    return isCOD && 
           o.fulfillment_status === 'fulfilled' && 
           orderDate >= fortyEightHoursAgo;
  }).length;

  const totalUnfulfilled = activeOrders.filter(o => {
    return o.fulfillment_status === null || o.fulfillment_status === 'restocked';
  }).length;

  safeSet('stat-products', totalProds);
  safeSet('stat-variants', totalVars);
  safeSet('stat-stock-total', totalStock);
  safeSet('stat-stock-low', lowStockCount);
  safeSet('stat-stock-out', outOfStockCount);
  safeSet('stat-orders-paid', paidFulfilled48h);
  safeSet('stat-orders-cod', codFulfilled48h);
  safeSet('stat-orders-unful', totalUnfulfilled);

  console.log('Stats Updated (48h):', { paidFulfilled48h, codFulfilled48h, totalUnfulfilled });
}

// 7. MISC HELPERS
window.toggleLoader = show => {
  const l = document.getElementById('global-loader');
  if(l) l.style.display = show ? 'flex' : 'none';
};

window.handleLogout = () => confirm("Logout?") ? window.location.href="/account/logout" : null;

// 8. AUTO-BOOT
window.addEventListener('load', bootSystem);
// Add this at the end of erp-core.js

async function fetchExchangeRates() {
  if (window.EXCHANGE_RATES_LOADED) return;
  window.EXCHANGE_RATES_LOADED = true;
  
  try {
    const res = await fetch(`https://api.exchangerate-api.com/v4/latest/${GLOBAL_CONFIG.BASE_CURRENCY}`);
    const data = await res.json();
    window.EXCHANGE_RATES = data.rates;
    console.log('✅ Exchange rates loaded from API');
  } catch (e) {
    console.warn('⚠️ API failed, using hardcoded rates');
    window.EXCHANGE_RATES = GLOBAL_CONFIG.EXCHANGE_RATES; // Use config rates
  }
}

// Load after 2 seconds (after bootSystem completes)
setTimeout(fetchExchangeRates, 2000);